import { memo, useEffect } from "react";
import Animated, {
	useAnimatedStyle,
	useSharedValue,
	withDelay,
	withSpring,
	WithSpringConfig,
	withTiming,
} from "react-native-reanimated";
import useStyle from "src/hooks/useStyle";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import { color } from "src/styles";

const springConfig: WithSpringConfig = {
	damping: 18,
	stiffness: 150,
};
const barPercent = 0.8;
const barMargin = (1 - barPercent) / 2;
const EditCoverSelectedUnderline = ({ widthLookup }: { widthLookup: Record<string, number> }) => {
	const widthSV = useSharedValue(0);
	const translateXSV = useSharedValue(0);
	const configs = useEditCoverGalleryStore((state) => state.configs);
	const curConfig = useEditCoverGalleryStore((state) => state.selectedTab);
	const opacitySV = useSharedValue(0);
	useEffect(() => {
		opacitySV.value = withDelay(100, withTiming(1, { duration: 500 }));
	}, [opacitySV]);

	useEffect(() => {
		if (!curConfig) return;
		const curWidth = widthLookup[curConfig.itemKey];
		const curIndex = configs.findIndex((config) => config.itemKey === curConfig.itemKey);
		if (curWidth) {
			let translateX = 0;
			for (let i = 0; i < curIndex; i++) {
				const curKey = configs[i]?.itemKey;
				if (curKey) {
					translateX += widthLookup[curKey] ?? 0;
				}
			}
			if (widthSV.value === 0) {
				widthSV.value = curWidth;
			} else {
				widthSV.value = withSpring(curWidth, springConfig);
			}
			translateXSV.value = withSpring(translateX, springConfig);
		}
	}, [configs, curConfig, translateXSV, widthLookup, widthSV]);

	const animatedStyle = useAnimatedStyle(
		() => ({
			width: barPercent * widthSV.value,
			transform: [{ translateX: translateXSV.value + barMargin * widthSV.value }],
			opacity: opacitySV.value,
		}),
		[translateXSV, widthSV, opacitySV],
	);
	const { theme } = useStyle();

	return (
		<Animated.View
			pointerEvents="none"
			style={[
				animatedStyle,
				{
					position: "absolute",
					bottom: 0,
					height: 2,
					backgroundColor: color.Text[theme],
				},
			]}
		/>
	);
};
export default memo(EditCoverSelectedUnderline);
